import { Grid } from '@rbx/ui';
import React, { FunctionComponent, ReactNode } from 'react';
import useContentTableRowStyles from './ContentTableRow.styles';

export interface ContentTableRowProps {
  name: ReactNode;
  summary: ReactNode;
  tags?: ReactNode;
  columnCount?: 1 | 2;
}

const ContentTableRow: FunctionComponent<React.PropsWithChildren<ContentTableRowProps>> = ({
  summary,
  name,
  tags,
  columnCount = 2,
}) => {
  const {
    classes: { name: nameStyle, empty, row, nameCol2, container },

    cx,
  } = useContentTableRowStyles();

  const nameColStyle = columnCount === 2 ? nameCol2 : null;

  return (
    <Grid item container XSmall className={row} direction='row'>
      <Grid className={cx(nameStyle, nameColStyle)}>{name}</Grid>
      <Grid className={!summary && !tags ? empty : container}>
        {summary}
        {tags}
      </Grid>
    </Grid>
  );
};

export default ContentTableRow;
